export default {
    help: 'Online podrška',
    options: {
        who_are_we: 'Ko smo mi?',
        what_is_bookeraj: 'Šta je Bookeraj?',
        how_you_can_improve: 'Kako možemo unaprijediti vaš biznis?',
        companies: 'Kompanije',
        company_registration: 'Registracija i podešavanje kompanije',
        company_users: 'Konfiguracija korisnika kompanije',
        inactivity_setup: 'Podešavanje neaktivnosti',
        users: 'Korisnici',
        user_profile_setup: 'Podešavanje profila korisnika',
        offers: 'Usluge',
        create_offer: 'Kreiranje usluge',
        offer_actions: 'Dodavanje korisnika na uslugu',
        finding_offer: 'Petraga usluga',
        chose: 'Molim vas izaberite od opcija...',
        create_discount: 'Kreiranje popusta',
    },
}
